import type {ResponsiveValue} from '@tempo/core';
import type {Breakpoint} from '@deezer/next/services/types/breakpoints';
import {getBreakpointValue} from '@deezer/next/shared/theme/utils';
import type {Column} from './types';
import {useResponsiveBooleanDisplay} from '@deezer/next/shared/hooks/useResponsiveBooleanDisplay';

export const useTableCellDisplayValue = (
	responsiveBoolean: ResponsiveValue<boolean> | undefined,
) => useResponsiveBooleanDisplay(responsiveBoolean, 'table-cell');

export const countVisibleColumns = (
	columns: Column[],
	currentBreakpoint?: Breakpoint,
) => {
	if (!currentBreakpoint) return columns.length;

	return columns.filter(column => {
		if (!column.display) return true;
		return getBreakpointValue(column.display, currentBreakpoint, true);
	}).length;
};
